module.exports = __webpack_public_path__ + "static/media/ic_challenged_red.d5c557f0.svg";